import React from 'react';
import { useEffect } from 'react';
import Carousel from '../components/Carousel';
import { Typography, Link } from '@mui/joy';
import { Box } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';

const Contacts = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        document.title = 'NASCAR — Контакты';
    }, []);

    return <div className="page" style={{ display: 'flex', justifyContent: 'space-between', flexDirection: isMobile ? 'column' : 'row' }}>
        <section>
            <h2>Контакты</h2>
            <div>
                <h3>Единый номер:</h3>
                <p>
                    <Link
                        href="tel:+375173884387"
                        sx={{
                            color: '#333',
                            textDecoration: 'none',
                            '&:hover': {
                                color: 'red',
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        +375 (17) 388-43-87
                    </Link>
                </p>
                <p>
                    <Link
                        href="tel:+375333124450"
                        sx={{
                            color: '#333',
                            textDecoration: 'none',
                            '&:hover': {
                                color: 'red',
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        +375 (33) 312-44-50
                    </Link>
                </p>

            </div>
        </section>
        <section style={{ margin: '20px 0', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ px: 2, py: 1 }}>
                <Typography level='title-lg'>Ваш комфорт — в наших руках.</Typography>
            </Box>
            <Carousel
                images={[
                    { image: './img/sklad/1.jpg' },
                    { image: './img/sklad/2.jpg' },
                    { image: './img/sklad/3.jpg' },
                ]}
                height={isMobile ? '250px' : '400px'}
                width={isMobile ? 'auto' : '600px'}
            />

            <Box sx={{ p: 2, mt: 2 }}>
                <Typography level='title-lg'>Как добраться до склада?</Typography>
                <iframe frameBorder={'0'} style={{ marginTop: '10px', width: '100%', minHeight: '250px', borderRadius: '30px' }} src="https://yandex.by/map-widget/v1/-/CLCjQfq"></iframe>
            </Box>
        </section>
    </div>
        ;
};

export default Contacts;
